/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import { showModal } from "actions";
// import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import "components/widgets/training/Training.css";
import { Trans } from "react-i18next";

class RegisteredEmployee extends Component {
  state = {
    showingChildren: false,
  };

  componentDidMount() {
    // console.log(this.props.t);
  }

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  renderTrainingMethodIcon = (value) => {
    switch (value) {
      case 3:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-tv">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </span>
          </td>
        );
      case 1:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-live-tv "></span>
          </td>
        );
      default:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-class"></span>
          </td>
        );
    }
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateTime = (dateString) => {
    return `${this.renderDate(dateString)} ${this.renderTime(
      dateString
    ).replace(/(:\d{2}| [AP]M)$/, "")}`;
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Eğitim">10015</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.employee.name}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Departman">10528</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.department?.name}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Pozisyon">10064</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.position?.name}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Yer">10016</Trans>
                  </div>
                </td>
                <td className="showGrup">{t.trainingLocation}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Başlangıç">10020</Trans>
                  </div>
                </td>
                <td className="showGrup">{this.renderDateTime(t.startDate)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="4">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Bitiş">10021</Trans>
                  </div>
                </td>
                <td className="showGrup">{this.renderDateTime(t.endDate)}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <tr>
            {this.renderTrainingMethodIcon(t.trainingMethod?.value)}
            <td className="showGrup">{t.employee.name}</td>
            <td className="showGrup">{t.training.name}</td>
            <td className="showGrup">{t.department?.name}</td>
            <td className="showGrup">{t.position?.name}</td>
            <td className="showGrup">{t.trainingLocation}</td>
            <td className="showGrup">{this.renderDateTime(t.startDate)}</td>
            <td className="showGrup">{this.renderDateTime(t.endDate)}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr className={this.rowClassName} onClick={this.ToggleChildren}>
            {this.renderTrainingMethodIcon(t.trainingMethod?.value)}
            <td className="showGrup">{t.training.name}</td>
          </tr>
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { showModal })(RegisteredEmployee);
